import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { privacy_path, refund_path, terms_path } from "@/lib/routes";
import { Link, router, usePage } from "@inertiajs/react";
import { ChevronDownIcon, LogOutIcon, ToyBrick } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getBaseUrl, getStoreUrl } from "@/lib/utils";
import useTranslations from "@/hooks/use-translations";

export function UserNavigation() {
  const { authenticated, current_user } = usePage().props;
  const { t } = useTranslations("shared.components.header_navigation");

  return (
    <div className="flex items-center gap-3">
      {authenticated ? (
        <>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="rounded-full w-auto"
              >
                <Avatar>
                  <AvatarFallback className="text-white bg-primary font-semibold">
                    {current_user.email[0].toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <ChevronDownIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="max-w-64">
              <DropdownMenuItem asChild>
                <a href={getStoreUrl("admin")}>{t("go_to_dashboard")}</a>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onSelect={() => router.delete("/session")}>
                <LogOutIcon />
                {t("sign_out")}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      ) : (
        <>
          <Button asChild variant="outline" size="lg">
            <Link href="/sign_in">{t("log_in")}</Link>
          </Button>
          <Button asChild size="lg">
            <Link href="/sign_up">{t("sign_up")}</Link>
          </Button>
        </>
      )}
    </div>
  );
}

export default function HeaderNavigation() {
  const { t } = useTranslations();

  return (
    <header className="flex w-full items-center justify-center px-8 py-4.5 border-b border-border bg-white">
      <div className="flex w-full justify-between gap-16">
        <div className="flex items-center gap-5">
          <Link className="flex items-center gap-2 font-bold" href="/">
            <ToyBrick className="size-8" /> BrickGestor
          </Link>
        </div>

        <ul className="flex flex-1 items-center gap-6">
          <li>
            <Link href={terms_path()}>{t("site.footer.terms")}</Link>
          </li>
          <li>
            <Link href={privacy_path()}>{t("site.footer.privacy")}</Link>
          </li>
          <li>
            <Link href={refund_path()}>{t("site.footer.refund")}</Link>
          </li>
        </ul>

        <UserNavigation />
      </div>
    </header>
  );
}
